import React, { useState } from 'react';

import './CheckCertification.css';

import HeaderInsideFooter from './HeaderInsideFooter';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import Diploma from '../../../diploma/Diploma';


const CheckCertification = () => {

  const [certificationId, setCertificationId] = useState('');

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);


  /* =========================
     CAUTARE CERTIFICAT
  ========================= */

  const handleSearch = async () => {

    const code = certificationId
      .trim()
      .toUpperCase();


    if (!code) {

      setError(
        'Introdu un cod de certificat.'
      );

      setResult(null);

      return;
    }


    try {

      setLoading(true);
      setError(null);
      setResult(null);


      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/verify/${encodeURIComponent(code)}`
      );


      const data = await response.json();


      /* =========================
         CERTIFICAT NEGASIT
      ========================= */

      if (response.status === 404) {

        setError(
          'Certificatul nu a fost gasit.'
        );

        return;
      }


      /* =========================
         EROARE SERVER
      ========================= */

      if (!response.ok) {

        throw new Error(
          data?.error ||
          'Certificatul nu a putut fi verificat'
        );

      }


      /* =========================
         CERTIFICAT REVOCAT
      ========================= */

      if (!data.valid) {

        setError(
          'Certificatul exista, dar nu mai este valid.'
        );

        setResult(data);

        return;
      }


      /* =========================
         CERTIFICAT VALID
      ========================= */

      setResult(data);


    } catch (error) {

      console.error(
        'Eroare verificare certificat:',
        error
      );


      setError(
        'Certificatul nu a putut fi verificat.'
      );


    } finally {

      setLoading(false);

    }

  };


  const certificate =
    result?.certificate;


  return (

    <div className="check-certification-page">

      <HeaderInsideFooter />


      <div className="certification-content">


        {/* =========================
            STANGA
        ========================= */}

        <div className="certification-left">

          <div className="certification-search-section">


            <h1 className="certification-title">
              Cautare Certificat
            </h1>


            <form
              className="certification-search-box"
              onSubmit={(event) => {

                event.preventDefault();

                handleSearch();

              }}
            >

              <input
                type="text"
                className="certification-input"
                placeholder="CL-TAFKJZ8P"
                value={certificationId}
                onChange={(event) =>
                  setCertificationId(
                    event.target.value
                  )
                }
                aria-label="ID certificat"
              />


              <button
                type="submit"
                className="certification-search-button"
                aria-label="Cauta certificatul"
              >

                <FontAwesomeIcon
                  icon={faSearch}
                  className="certification-search-icon"
                />

              </button>

            </form>


            <p className="certification-note">
              * ID-ul certificatului este localizat
              in partea de jos a certificatului
            </p>


            {/* LOADING */}

            {loading && (

              <div className="certification-search-status">
                Se verifica certificatul...
              </div>

            )}


            {/* EROARE */}

            {!loading && error && (

              <div className="certification-search-error">
                {error}
              </div>

            )}


            {/* VALID */}

            {!loading &&
              result?.valid &&
              certificate && (

              <div className="certification-search-valid">

                <div className="certification-valid-icon">
                  ✓
                </div>

                <div>

                  <strong>
                    Certificat valid
                  </strong>

                  <span>
                    {certificate.student_name}
                  </span>

                </div>

              </div>

            )}

          </div>

        </div>


        {/* =========================
            DREAPTA
        ========================= */}

        <div className="certification-right">

          <div className="certification-info-section">


            {result?.valid && certificate ? (

              /* =========================
                 CERTIFICAT GASIT
              ========================= */

              <>

                <h3 className="info-question">
                  Certificat verificat
                </h3>


                <p className="info-answer">
                  Acest certificat este valid si
                  a fost emis de ContaLearn.
                </p>


                <div className="certificate-preview-wrapper">

                  <Diploma
                    certificateData={certificate}
                    publicView={true}
                  />

                </div>

              </>

            ) : (

              /* =========================
                 EXEMPLU INITIAL
              ========================= */

              <>

                <h3 className="info-question">
                  Certificatul tau ContaLearn
                </h3>


          <div className="certificate-preview-wrapper certificate-demo-preview">

  <div className="certificate-preview-watermark">
    PREVIEW
  </div>

  <Diploma
    previewUser={{
      id: 'DEMO-2026-001',
      username: 'Andrei Popescu'
    }}
    previewMode
  />

</div>


                <h3 className="info-question">
                  Cum obtin o certificare ContaLearn?
                </h3>


                <p className="info-answer">
                  Completeaza o sectiune de curs sau
                  un curs eligibil pe ContaLearn.
                </p>


                <h3 className="info-question">
                  De ce ar trebui sa obtii o certificare ContaLearn?
                </h3>


                <p className="info-answer">
                  Evidentiaza-te in fata angajatorilor
                  demonstrand abilitatile tale practice
                  in contabilitate cu certificarea ContaLearn.
                </p>


                <h3 className="info-question">
                  Poate fi afisata pe LinkedIn sau alta platforma?
                </h3>


                <p className="info-answer">
                  Da. Certificatul poate fi descarcat
                  in format PDF si distribuit impreuna
                  cu linkul public de verificare.
                </p>

              </>

            )}

          </div>

        </div>


      </div>

    </div>

  );

};


export default CheckCertification;